import Swiper from 'swiper';

export default function carouselWithDescription() {
    $('.carousel-with-description').each(function (index) {

        let $this = $(this).find('.swiper-container');

        $('.gallery-img').each(function (ind) {
            $(this).addClass('gallery-img-' + ind);
        });

        $('.gallery-thumbs').each(function (ind) {
            $(this).addClass('gallery-thumb-' + ind);
        });

        let galleryThumbs = new Swiper('.gallery-thumb-' + index, {
            spaceBetween: 0,
            slidesPerView: 'auto',
            loop: false,
            watchSlidesVisibility: true,
            watchSlidesProgress: true,
            allowSlidePrev: false,
            allowSlideNext: false,

            pagination: {
                el: '.swiper-pagination',
                clickable: true,
            },

            breakpoints: {
                1023: {
                    slidesPerView: 1,
                    allowSlidePrev: true,
                    allowSlideNext: true,
                    speed: 500,
                    resistanceRatio: 0,

                }
            }

        });

        let galleryTop = new Swiper('.gallery-img-' + index, {
            speed: 500,
            spaceBetween: 0,
            slidesPerView: 'auto',
            loop: true,

            autoplay: {
                delay: 7000,
                waitForTransition: false,
                disableOnInteraction: false,
            },

            thumbs: {
                swiper: galleryThumbs,
            },

            breakpoints: {
                1023: {
                    slidesPerView: 1,
                    loop: false,
                    resistanceRatio: 0,
                },
            },
        });

        galleryTop.on('slideChange', function () {
            galleryThumbs.slideToLoop(this.realIndex);
        });

        galleryThumbs.on('slideChange', function () {
            galleryTop.slideToLoop(this.realIndex);
        });

        $('.swiper-wrapper').on('mouseover', '.swiper-slide-thumb-active', function () {
            if (window.innerWidth >= 1023) {
                galleryTop.autoplay.stop();
            }

        });
        $('.swiper-wrapper').on('mouseleave', '.swiper-slide-thumb-active',  function () {
            if (window.innerWidth >= 1023) {
                galleryTop.autoplay.start();
            }

        });


    });
}